import { Component, Inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { AddOwnTemplateDialogComponent } from '../../../add-own-template-dialog/add-own-template-dialog.component';
import { QnSbnDataService } from '../../../../services/qn-sbn-data-service.service';
import { CreateReminderComponent } from '../../create-reminder/create-reminder.component';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'dl-reminder-message-template-dialog',
  templateUrl: './reminder-message-templete-dialog.component.html',
  styleUrls: ['./reminder-message-template-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReminderMessageTemplateDialogComponent implements OnInit {

  public constructor(
    private readonly dialog: MatDialog,
    public dialogRef: MatDialogRef<ReminderMessageTemplateDialogComponent>,
    private _QnSbnDataService: QnSbnDataService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly oneSnackBar?: OneSnackBarService
  ) {
    this.isDialogMode = !!(data && data.isDialogMode);
    this.notificationData = data?.notificationData;
  }

  public templateColumn: any;
  public templateData: any;
  public newReminderTemplate: Subject<any> = new Subject<any>();
  public isAffBtnDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public remindersData = [];
  public feedbackDueDate = new FormControl('');
  public addMoreReminders: Subject<any> = new Subject<any>();
  private readonly isDialogMode: boolean;
  private readonly notificationData: any;

public ngOnInit(): void {
  this.templateColumn = this.data?.columnData || [];
  this.templateData = Array.isArray(this.data?.tableData) ? this.data.tableData : [];
  if (Array.isArray(this.data?.remindersData)) {
    this.remindersData = [...this.data.remindersData];
  }

  if (this.data?.feedbackDueDate) {
    this.feedbackDueDate.setValue(this.data.feedbackDueDate);
  }

  if (!this.isDialogMode) {
    this._QnSbnDataService.mappingData$.subscribe(observer => {
      if (!this._QnSbnDataService.isEmpty(observer['feedbackDueDate'])) {
        this.feedbackDueDate.setValue(new Date(observer['feedbackDueDate']['feedbackDueDate']));
      }
      if (!this._QnSbnDataService.isEmpty(observer['notificationReminders'])) {
        this.remindersData = observer['notificationReminders']['remindersData'];
        this.addMoreReminders.next(this.remindersData);
        this.changeDetectorRef.detectChanges();
      }
    });
  }
}

public feedbackOptionAdded(isAdded: boolean): void {
  this.isAffBtnDisabled = isAdded;
  this.isNtBtnDisabled = !isAdded;
}

public getSelectedRowInTemplate(rows: any): void {
  this.selectedRow = rows.messageSelected.slice(-1);
  const isSelected = this.selectedRow.length > 0;
  this.isAffBtnDisabled = !isSelected;
  this.isNtBtnDisabled = isSelected;
}

public addTemplateToForm(): void {
  const newData = {
    newColumnData: ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'],
    newTableData: this.selectedRow
  };
  if (!this.isDialogMode) {
    this.dialogRef.close({ data: newData });
    this._QnSbnDataService.getMappedQnsbnData({
      reminderSubjectName: this.selectedRow[0].templateDetails.templateSubject,
      reminderAttachmentRTEText: this.selectedRow[0].templateDetails.templateBody,
      templateId: this.selectedRow[0].templateId || ''
    }, 'reminderAttachment');
    this.addReminderMessage(false);
    return;
  }

  this.addReminderMessage(false, this.selectedRow[0]);
}

public addReminderMessage(blank: boolean, templateSeed?: any): void {
  const dialogRef = this.dialog.open(CreateReminderComponent, {
    data: {
      feedbackDueDate: this.feedbackDueDate.value,
      isEdit: false,
      isBlank: blank,
      isDialogMode: this.isDialogMode,
      notificationData: this.notificationData,
      templateSeed,
      remindersData: this.remindersData
    },
    disableClose: true,
    autoFocus: false,
    panelClass: 'reminder-modalbox'
  });
  dialogRef.afterClosed().subscribe(result => {
    if (!result || !result.data) {
      return;
    }
    this.remindersData = [...this.remindersData, ...result.data];
    this.changeDetectorRef.detectChanges();
    this.addMoreReminders.next(this.remindersData);
    this.addProduct(this.feedbackDueDate.value, this.remindersData);
    this.changeDetectorRef.detectChanges();
    if (this.isDialogMode) {
      this.dialogRef.close({ 
        createdReminders: result.data,
        shouldCreateTemplate: result.shouldCreateTemplate || false
      });
      return;
    }
    this.dialogRef.close();
  });
}

public addProduct(newDate,reminderData) {
  if (this.isDialogMode) {
    return;
  }
  this._QnSbnDataService.getMappedQnsbnData({
    "feedbackDueDate":newDate      
  },"FeedbackDueDate");
  this._QnSbnDataService.getMappedQnsbnData({
    "remindersData":reminderData      
  },"NotificationReminders"); 
}

ngOnDestroy(): void {
  this.addProduct(this.feedbackDueDate.value,this.remindersData);
}

createBlankReminder(){
  this.selectedRow = [];
  const dialogRef = this.dialog.open(CreateReminderComponent, {
    data: {
      feedbackDueDate: this.feedbackDueDate.value,
      isEdit: false,
      isDialogMode: this.isDialogMode,
      notificationData: this.notificationData,
      remindersData: this.remindersData
    },
    disableClose: true,
    autoFocus: false,
    panelClass: 'reminder-modalbox'
  });
}
}
